function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "206",
  height: "149",
  viewBox: "0 0 206 149",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: ".18",
  d: "M111.057 17.99c-18.66 2.992-37.656 3.017-56.466 4.826-9.73.937-64.27 28.601-53.098 87.431 4.1 21.672 25.821 39.239 47.854 38.277 18.72-.817 20.782-13.153 54.143-13.853 25.333-.531 44.863 17.545 74.209 7.111 13.005-4.624 23.366-16.291 26.686-29.685 3.32-13.395-1.495-28.868-12.828-36.77-5.875-4.11-13.379-6.338-17.564-12.17-8.203-11.43 8.409-29.11 1.019-41.079-14.688-23.81-48.293-6.59-63.955-4.087z",
  fill: "#495AB9"
})), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M45.386 34.801S25.68 29.9 42.745 22.837c17.065-7.06 96.284-14.857 125.286 1.12 0 0 19.892.553 20.437 3.342.546 2.79-2.362 5.045-2.362 5.045l-10.087.341s-1.857-4.02-11.151 3.283C155.574 43.27 45.387 34.8 45.387 34.8z",
  fill: "#000405"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.545 34.759c0-8.604-26.809-15.576-59.876-15.576-33.067 0-59.88 6.98-59.88 15.576a4.848 4.848 0 00.997 2.841c5.13 7.246 29.54 12.737 58.883 12.737 29.343 0 53.749-5.484 58.879-12.737a4.856 4.856 0 00.997-2.841z",
  fill: "#495AB9"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M164.134 37.6c-5.137-7.245-29.543-12.731-58.878-12.731-29.336 0-53.744 5.483-58.881 12.731 5.127 7.246 29.538 12.737 58.881 12.737s53.749-5.491 58.878-12.737z",
  fill: "#000405"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M105.419 30.604c27.003 0 48.894 3.992 48.894 8.916 0 4.923-21.891 8.915-48.894 8.915s-48.894-3.992-48.894-8.916c0-4.923 21.89-8.915 48.894-8.915z",
  fill: "#000405"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.681 40.444s3.427-7.497-40.649-7.789h-2.552c-11.75 0-20.249.618-26.398 1.496h-.017c-15.74 2.243-16.031 6.273-16.031 6.273L33.588 146.008l45.643.182 95.168.371-26.718-106.117z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.777 42.42l-.122-.091c-.097-.073-.204-.16-.322-.25a10.812 10.812 0 01-.97-.912c-.889-.952-1.427-1.91-1.432-2.821a2.151 2.151 0 01.341-1.174l.023.184-1.446-1.39-.115-.11.12-.105 3.512-3.168.07-.062.087.037 4.185 1.76h-.105l.072-.032.21-.088.747-.314a90.956 90.956 0 013.228-1.256c1.603-.583 2.841-.96 3.58-1.057l-.123.19-1.86-5.853-.042-.137.135-.047 3.207-1.117-.1.135.046-1.673h.294l-.045 1.673v.102l-.095.032-3.207 1.117.092-.182 1.864 5.847.055.167-.175.023c-.707.095-1.931.466-3.516 1.044l-.82.304c-.795.302-1.61.626-2.398.947l-.748.314-.207.088-.072.03-.057.024-.058-.024-4.184-1.76.154-.025-3.524 3.158v-.214l1.443 1.39.087.083-.065.102a1.852 1.852 0 00-.294 1.014c0 .82.499 1.72 1.354 2.622a10.603 10.603 0 001.253 1.14l.117.087-.174.249zM67.041 28.974l.184-.03.534-.082c.576-.092 1.226-.192 1.941-.302 2.04-.309 4.168-.618 6.279-.907a262.94 262.94 0 013.113-.411c4.79-.609 8.412-.943 10.403-.91h.097l.038.09.997 2.41-.145-.09h.077l.23-.015.84-.055a258.33 258.33 0 015.027-.277c2.23-.102 3.975-.146 5.044-.114l-.152.135.469-6.96v-.139h.775l1.68.022c1.745.028 3.474.068 5.097.12 4.06.132 6.692.324 7.33.603l.095.043v.102l-.185 2.789-.064-.132 4.925 3.24-.073-.025h.137l.387.03 1.373.105c1.423.117 2.844.249 4.172.391 2.829.309 4.836.63 5.683.962l-.194.102.713-2.829.019-.082.083-.025 8.182-2.323h.073l6.879 1.496-.122.03 1.495-1.207.184.227-1.495 1.206-.055.045-.067-.015-6.882-1.495h.073l-8.185 2.325.102-.107-.713 2.852-.043.162-.154-.06c-.813-.32-2.809-.64-5.608-.942a148.69 148.69 0 00-4.165-.392c-.498-.042-.957-.077-1.371-.107l-.383-.027h-.138l-.069-.025-4.925-3.24-.073-.045v-.088l.185-2.789.087.145c-.583-.25-3.24-.449-7.228-.578-1.62-.055-3.355-.093-5.092-.12l-1.677-.023h-.636l.147-.137-.466 6.962v.142h-.115c-1.059-.03-2.796.015-5.022.115a398.408 398.408 0 00-5.027.277l-.837.054-.23.015h-.184l-.04-.097-.997-2.413.132.092c-1.971-.032-5.585.302-10.36.908-.998.127-2.042.264-3.111.41-2.109.287-4.237.6-6.276.908-.713.107-1.364.21-1.94.3l-.53.084-.187.027-.065-.311zM96.55 19.42l-2.94 3.916-.05.067h-.07c-1.06-.122-4.611.105-9.84.584l-2.196.206c-1.872.18-3.774.372-5.608.564l-1.745.187-.48.052-.17.017h-.058l-.044-.032-3.29-2.393.172-.236 3.285 2.375-.103-.028.17-.017.48-.052 1.746-.187c1.834-.192 3.738-.384 5.608-.566l2.198-.204c5.264-.482 8.813-.71 9.902-.584l-.134.058 2.94-3.906.228.18zM159.789 28.368l.062 3.036-.077-.127.159.092a10.137 10.137 0 011.68 1.261c1.027.958 1.698 2.02 1.83 3.166l-.135-.13 1.613.122-.023.295-1.612-.125h-.12l-.015-.12c-.125-1.066-.748-2.071-1.745-2.99a9.524 9.524 0 00-1.223-.963 5.185 5.185 0 00-.404-.25 2.606 2.606 0 00-.15-.086l-.075-.04v-.1l-.062-3.036.297-.005z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.139 44.223a2.488 2.488 0 01-.155-.1c-.122-.08-.25-.174-.406-.281a10.485 10.485 0 01-1.214-1.065c-1.46-1.475-2.15-3.1-1.627-4.795l.279.084c-.484 1.57.164 3.099 1.557 4.504a9.903 9.903 0 001.728 1.391l-.162.262zM47.049 38.856a2.196 2.196 0 01-.22-.456c-.3-.856-.29-1.79.03-2.64.471-1.38 1.613-2.808 3.564-4.251a34.88 34.88 0 015.65-3.009l-.081.09 1.011-3.163.28.09-1.012 3.15-.023.065-.062.025a34.454 34.454 0 00-5.596 2.99c-1.899 1.407-2.99 2.785-3.452 4.106-.299.785-.311 1.65-.035 2.443.038.101.082.2.133.296.017.033.035.065.055.095l-.242.17zM159.657 40.905c0-.012.027-.032.052-.067.025-.035.092-.12.144-.192a7.09 7.09 0 00.444-.708c.583-1.079.815-2.176.499-3.193-.389-1.258-1.596-2.298-3.809-3.033-3.088-1.03-5.842-1.9-8.225-2.615-.831-.249-1.556-.462-2.176-.64l-.558-.157-.189-.052.142-.038-2.096 2.049-.05.05h-.07l-4.713-.556.117-.037-1.496 1.365-.196-.216 1.495-1.364.05-.047h.08l4.713.553-.12.04 2.096-2.049.06-.06.082.023.19.052.561.16c.618.177 1.345.391 2.178.64 2.383.718 5.139 1.588 8.225 2.618 2.295.762 3.576 1.866 3.988 3.225.339 1.106.092 2.278-.526 3.42a6.98 6.98 0 01-.461.747 3.36 3.36 0 01-.155.205.417.417 0 01-.06.074l-.216-.197z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.666 32.575l-18.825.643c-.225.015-5.379.666-12.086 1.58-2.61.357-11.891 3.121-12.711 5.621L33.588 146.008l45.643.182 26.42-113.535.015-.08z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.496 134.702a6.714 6.714 0 01-4.853 2.535c-2.642 0-1.366-2.472-.498-2.472a3.17 3.17 0 00.733-.07l1.086-.947 1.074-.96.282-.608s1.496.344 1.762-.052l.195 1.68v.326c.119.168.194.364.219.568zM180.012 134.57c0 .25-2.642 1.76-5.234 1.76s-1.366-2.492-.484-2.472h.88l.498-.25 1.895-.967.281-.608s1.496.344 1.763-.052l.194 1.707v.309c.118.17.189.368.207.573z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.829 133.997c.094.179.142.379.14.581 0 .249-2.642 1.759-5.234 1.759s-1.366-2.492-.484-2.472h.88l.499-.249 4.159.07.04.311z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.19 135.38a3.86 3.86 0 01-1.939 0c-.581-.316-.765-.555-.748-.8.018-.244.371-.952 1.762-.618 1.391.334 1.648 1.084 1.648 1.084l-.723.334zM186.496 134.702a6.714 6.714 0 01-4.853 2.535c-2.642 0-1.366-2.472-.498-2.472a3.17 3.17 0 00.733-.07l1.086-.947 3.338.06v.326c.112.17.179.366.194.568z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.114 136.163a3.874 3.874 0 01-1.937 0c-.583-.317-.768-.553-.748-.8.02-.247.369-.952 1.762-.616 1.394.337 1.683 1.047 1.683 1.047l-.76.369z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.604 105.872l2.632 26.101s1.762.636 2.547 0l1.091-20.558 3.091 20.74s1.443.932 2.333-.122l1.156-26.298s-9.222 1.897-12.85.137z",
  fill: "#495AB9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.604 105.648l2.632 26.106s1.762.633 2.547 0l1.091-20.558 3.091 20.73s1.443.932 2.333-.125l1.156-26.295s-9.222 1.901-12.85.142z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.854 81.177c.347.27.718.506 1.11.705a9.66 9.66 0 002.99 1.109c1.384.15 1.964 2.742 2.149 3.96.184 1.22 1.453 7.279 1.453 7.279a2.459 2.459 0 01-1.954 2.594c-2.243.73-2.186 1.092-2.186 1.092l.045 7.779s-10.107 2.455-12.836.142l.396-10.526 1.496-11.44 4.282-1.994 3.055-.7z",
  fill: "#495AB9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.854 81.177c.347.27.718.506 1.11.705a9.66 9.66 0 002.99 1.109c1.384.15 1.964 2.742 2.149 3.96.184 1.22 1.453 7.279 1.453 7.279a2.459 2.459 0 01-1.954 2.594c-2.243.73-2.186 1.092-2.186 1.092l.045 7.779s-10.107 2.455-12.836.142l.396-10.526 1.496-11.44 4.282-1.994 3.055-.7z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.87 80.95a2.642 2.642 0 01-3.509 1.28l-.103-.049s-2.185 3.794.942 3.345c1.658-.25 2.742-2.869 2.991-4.11l-.321-.466z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M184.585 94.02c.814-.191 1.617-.429 2.405-.713.274-.184-.397-5.149-.397-5.149s-.249 3.988-5.356 5.897c-2.492.932 1.71 2.208 1.71 2.208l1.638-2.243z",
  fill: "#000405"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M184.09 97.283s2.759 1.02 3.305.66v6.072s-7.049-4.569-7.049-5.281c0-.713-5.391-.878-5.391-.878v-1.662l8.185-.967s1.77-1.536.95 2.056z",
  fill: "#000405"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.559 93.93s0 2.493-.378 3.203c-.379.71-.619-1.76-.619-1.76l.997-1.443z",
  fill: "#033B4B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.031 77.916l-.07 1.296c-.035.616-.077 1.354-.107 1.97a4.135 4.135 0 01-1.261 2.756 4.675 4.675 0 01-1.541 1.047.82.82 0 01-1.044-.499.848.848 0 01-.02-.476c.157-.467.252-.953.284-1.445.01-.185.01-.37 0-.554a5.326 5.326 0 00-.122-1.014c-.473-1.191 3.37-2.866 3.826-3.063l.055-.018z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.988 77.929c-.204.556-.249 1.66-1.089 2.742-.382.498-1.408 1.622-2.627 1.891.012-.184.012-.369 0-.553a5.328 5.328 0 00-.122-1.014c-.461-1.182 3.382-2.87 3.838-3.066z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.227 70.484a4.173 4.173 0 00-3.931 4.69c.133 1.695.571 3.35 1.294 4.888 1.366 2.323 4.81.414 5.356-.546.546-.96 2.642-5.279 1.762-6.502-.573-.803-2.238-2.617-4.481-2.53z",
  fill: "url(#paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.586 68.866l.688.362a2.65 2.65 0 00-2.158 1.019 3.513 3.513 0 00-1.022 2.43l1.206-.573s-.087 1.478 2.186 1.593c2.273.114 4.686.201 4.686.201l-.775-1.064s1.435.573 1.664 1.092c.222.834.381 1.684.477 2.542 0 0 .573-1.45.792-1.134.219.317-.249 1.638-.546 1.937-.296.299-.249 1.161-.274 1.231-.025.07 1.411-1.117 1.481-1.523.069-.406 1.495-4.549.573-5.411l.573-.045a2.746 2.746 0 00-1.119-.431s-3.746-4.89-8.432-2.226z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.517 83.933s-1.762.773-1.994 4.237a33.78 33.78 0 01-1.231 6.598 39.944 39.944 0 01-4.011.202l1.957 1.495a5.915 5.915 0 002.492 1.117l1.349.299 1.438-13.948z",
  fill: "#495AB9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.051 95.83a.788.788 0 010 .097.724.724 0 01-.748.626l-13.21-.748a.69.69 0 01-.326-.097.696.696 0 01-.379-.387l-2.884-8.225a.723.723 0 01.095-.66.727.727 0 01.601-.3l9.169.16a.723.723 0 01.678.528l2.009 7.216a.723.723 0 00.591.518l3.753.556a.718.718 0 01.651.716z",
  fill: "#495AB9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.051 95.83a.788.788 0 010 .097.724.724 0 01-.748.626l-13.21-.748a.69.69 0 01-.326-.097.696.696 0 01-.379-.387l-2.884-8.225a.723.723 0 01.095-.66.727.727 0 01.601-.3l9.169.16a.723.723 0 01.678.528l2.009 7.216a.723.723 0 00.591.518l3.753.556a.718.718 0 01.651.716z",
  fill: "url(#paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.464 95.416a.998.998 0 01-.658 0 2.564 2.564 0 01-.628-.217c-.362-.197-1.149-.92-1.887-.713a5.486 5.486 0 01-1.994.105c-.272-.062-.272-.135-.536-.105-.264.03-.249-.319-.249-.319a11.05 11.05 0 012.56-1.216 7.689 7.689 0 012.644.538l.573.33.035.017.309.18s.013 1.263-.169 1.4z",
  fill: "url(#paint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.775 92.97l-1.217-.66s-.201.327-.079.499c.065.085.139.162.222.23.349-.098.715-.12 1.074-.068z",
  fill: "url(#paint9_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.471 95.997a3.411 3.411 0 001.834 1.246c1.321.421 3.691-.441 3.691-.441s.776-.352.633-.431c-.142-.08-3.945-.23-3.945-.23l-2.213-.144z",
  fill: "url(#paint10_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.176 133.857s.882.449.934 1.144l.07.379s3.308-.635 3.684-1.383l-.159-1.162a1.706 1.706 0 01-1.516.546c-.783-.237-.633-.747-.633-.747l-2.38 1.223zM182.178 134.852l-.289-.15 2.158-1.926s.466 1.126 2.106.219l.192 1.127a7.583 7.583 0 01-3.452 2.086 1.742 1.742 0 00-.715-1.356z",
  fill: "#495AB9"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".61",
  d: "M175.176 133.857s.882.449.934 1.144l.07.379s3.308-.635 3.684-1.383l-.159-1.162a1.706 1.706 0 01-1.516.546c-.783-.237-.633-.747-.633-.747l-2.38 1.223z",
  fill: "url(#paint11_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".61",
  d: "M182.178 134.852l-.289-.15 2.158-1.926s.466 1.126 2.106.219l.192 1.127a7.583 7.583 0 01-3.452 2.086 1.742 1.742 0 00-.715-1.356z",
  fill: "url(#paint12_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.357 96.194l-4.984-.264-4.669-.25a.718.718 0 01-.326-.371l-.282-.818-1.024-2.93-1.551-4.452a.764.764 0 01.115-.25l4.591.06 4.853.065a.561.561 0 01.498.484c.07.458 1.994 7.796 1.994 7.796a1.465 1.465 0 00.785.93z",
  fill: "#495AB9"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M178.357 96.194l-4.984-.264-4.669-.25a.718.718 0 01-.326-.371l-.282-.818-1.024-2.93-1.551-4.452a.764.764 0 01.115-.25l4.591.06 4.853.065a.561.561 0 01.498.484c.07.458 1.994 7.796 1.994 7.796a1.465 1.465 0 00.785.93z",
  fill: "#000405"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".05",
  d: "M178.338 94.713s.625 1.364 0 1.478l4.018.167s.441-.105.396-.431a1.335 1.335 0 00-.396-.65l-3.831-.5-.187-.064z",
  fill: "#000405"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.322 95.917c.095-.022.135-.204.09-.409-.045-.204-.162-.351-.249-.329-.088.023-.135.205-.088.409.048.204.157.352.247.329z",
  fill: "#C7FDFB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.563 96.194l-4.052-.167-4.668-.25a.706.706 0 01-.327-.378l-.282-.818 8.659.202c.112.516.341.998.67 1.41z",
  fill: "#495AB9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.479 107.148s.433 3.52 1.393 4.25l-.299-4.135-1.094-.115zM185.713 106.064l.414 26.051 1.311-26.417-1.725.366z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.465 95.416a.997.997 0 01-.658 0c.61-.154.481-1.598.481-1.598l.035.018.309.18s.015 1.263-.167 1.4z",
  fill: "url(#paint13_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.823 108.975l-.706 23.215c.241-.01.474-.085.676-.217l1.091-20.575-1.061-2.423z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".13",
  d: "M170.217 86.932l-.154.356-2.642 4.561-.352-.286-1.548-4.452a.763.763 0 01.115-.25l4.581.07z",
  fill: "url(#paint14_linear)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: "104.539",
  y1: "32.643",
  x2: "103.994",
  y2: "146.347",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".01",
  stopColor: "#fff",
  stopOpacity: ".4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: "17644.4",
  y1: "-71501.4",
  x2: "17248.7",
  y2: "-19640.4",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".01",
  stopColor: "#fff",
  stopOpacity: ".4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fff",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: "160.798",
  y1: "124.252",
  x2: "196.587",
  y2: "114.429",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68E1FD",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".02",
  stopColor: "#66DAF6",
  stopOpacity: ".04"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".18",
  stopColor: "#58A1BC",
  stopOpacity: ".39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".35",
  stopColor: "#4D758F",
  stopOpacity: ".66"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".53",
  stopColor: "#45566F",
  stopOpacity: ".85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".73",
  stopColor: "#40435C",
  stopOpacity: ".96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".99",
  stopColor: "#3F3D56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: "181.801",
  y1: "93.995",
  x2: "157.098",
  y2: "95.119",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".91",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: "179.963",
  y1: "81.473",
  x2: "184.031",
  y2: "81.473",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: "2869.26",
  y1: "2003.06",
  x2: "2961.71",
  y2: "2326.06",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: "5986.3",
  y1: "4362.72",
  x2: "6286.72",
  y2: "4362.72",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: "11809.4",
  y1: "3597.57",
  x2: "11825.6",
  y2: "2851.9",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".91",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: "4341.58",
  y1: "1291.33",
  x2: "4491.93",
  y2: "1291.33",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: "1098.89",
  y1: "433.801",
  x2: "1106.05",
  y2: "433.801",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: "4223.11",
  y1: "757.001",
  x2: "4376.15",
  y2: "757.001",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: "178.575",
  y1: "135.487",
  x2: "176.751",
  y2: "132.048",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#00272E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: "3341.01",
  y1: "2339.61",
  x2: "3307.89",
  y2: "2288.47",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#00272E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: "763.212",
  y1: "879.128",
  x2: "781.966",
  y2: "904.603",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECC4D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".42",
  stopColor: "#EFD4D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F2EAC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: "165.512",
  y1: "89.354",
  x2: "170.217",
  y2: "89.354",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68E1FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#69B9EB"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h205.425v148.561H0z"
})))));